import { ChangeDetectionStrategy, Component, Injector, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
    IOnboardingReportParameter,
    IOnboardingReportParticipant,
    IOnboardingReportSummary,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiOnboardingReportDetailsBase } from '../fi-onboarding-report-details-base';

@Component({
    selector: 'fi-onboarding-report-participants-onboarded-widget',
    templateUrl: './fi-onboarding-report-participants-onboarded-widget.component.html',
    styleUrl: './fi-onboarding-report-participants-onboarded-widget.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-report-participants-onboarded-widget' },
    standalone: false,
})
export class FiOnboardingReportParticipantsOnboardedWidgetComponent extends FiOnboardingReportDetailsBase {
    private _onboardingParticipants$ = new BehaviorSubject<IOnboardingReportParticipant[]>([]);
    protected get onboardingParticipants$(): Observable<IOnboardingReportParticipant[]> {
        return this._onboardingParticipants$.asObservable();
    }

    private _participantsSummary$ = new BehaviorSubject<IOnboardingReportSummary>(undefined);
    protected get participantsSummary$(): Observable<IOnboardingReportSummary> {
        return this._participantsSummary$.asObservable();
    }

    protected loadReportData() {
        const parameter = this.getReportParameter();
        this.fiOnboardingReportService.getReportData(parameter).then((result) => {
            this._onboardingParticipants$.next(result.OnboardingParticipants);
            this._participantsSummary$.next(result.ParticipantsSummary);
            this.checkLoadAvailableBusinessUnits();
        });
    }
    private getReportParameter(): IOnboardingReportParameter {
        const parameter = this.fiOnboardingReportHelperService.getReportParameter({
            widget: this.widget,
            filter: this.currentFilter,
            dateRange: this.fiOnboardingReportDateService.getDateRange(this.widget.Id),
            loadOnboardingParticipants: true,
            loadParticipantsSummary: true,
        });
        parameter.SearchText = this.searchText;
        return parameter;
    }

    protected checkLoadAvailableBusinessUnits() {
        const availableItemsByData =
            this.fiOnboardingReportTableFilterHelperService.getAvailableUnitsAreasBusinessAreas(
                this.availableItems.Onboardings,
                this.currentFilter.OnboardingIds,
                this.currentFilter,
                this.availableItems,
                { hideDeactivatedUnits: true },
            );
        this.availableItemsByDataChange.emit(availableItemsByData);
    }
}
